"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pick = pick;
exports.getKeys = getKeys;
exports.toBoolean = toBoolean;
exports.deepClone = deepClone;
exports.areStringArraysEqual = areStringArraysEqual;
function pick(obj, keys) {
    const copy = {};
    keys.forEach((key) => (copy[key] = obj[key]));
    return copy;
}
function getKeys(template) {
    return Object.keys(template);
}
function toBoolean(value) {
    if (typeof value === "boolean") {
        return value;
    }
    if (typeof value === "string") {
        const lowerValue = value.trim().toLowerCase();
        return lowerValue === "true" || lowerValue === "1";
    }
    if (typeof value === "number") {
        return value > 0; // Treat 0 as false and any non-zero number as true
    }
    // Handle cases where value is not a string, number, or boolean
    return false;
}
function deepClone(obj) {
    if (obj === null || typeof obj !== "object") {
        return obj; // Return the value if obj is not an object
    }
    if (Array.isArray(obj)) {
        return obj.map((item) => deepClone(item)); // Clone arrays
    }
    const clonedObj = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            clonedObj[key] = deepClone(obj[key]); // Clone objects
        }
    }
    return clonedObj;
}
function areStringArraysEqual(a, b) {
    if (a.length !== b.length)
        return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((val, index) => val === sortedB[index]);
}
